import AddreeseeDetails from './AddreeseeDetails';
export default AddreeseeDetails;
export { default as AddreeseeDetails } from './AddreeseeDetails';